import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModalConfirmation from './ModalConfirmation';
import Confirm from '../../components/Confirm';
import Table, { ExpandableRow, ExpandedRow } from '../../components/ExpandableTable';


import actions from './actions';

class ListaAtividadesPendentes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      isOpenOutOfOrder: false,
      isOpenError: false,
      value: {}
    };
  }

  componentDidMount() {
    this.props.actions.onLoadTodasTarefas();
  }

  toggle = key => () => {
    this.setState(state => ({
      [key]: !state[key]
    }));
  };

  confirm = ({ value, observacao }) => {
    if (value.confirmacao) {
      this.setState({
        value,
        isOpenOutOfOrder: false,
        isOpen: true
      });
    } else {
      this.setState({
        isOpenOutOfOrder: false,
      });

      this.confirmModal(value)({
        observacao
      });
    }
  };

  onStartConfirmation = value => e => {
    e.preventDefault();
    e.stopPropagation();

    const { value: { result } } = this.props;

    if (0 < result.findIndex(v => v === value)) {
      this.setState({
        value,
        isOpenOutOfOrder: true
      });
    } else {
      console.log(value);
      this.confirm({ value, observacao: "Tarefa concluída na ordem." });
    }
  };

  confirmModal = value => data => {
    this.props.actions.onConfirmTask({
      value,
      ...data
    }).catch(({message}) => {
      switch (message) {
        case 'VALIDATION_OMIT':
          this.setState({
            isOpenError: true,
            message: 'Verifique se clicou na tarefa correta ou se apontou para o QR CODE correto.'
          });
          break;
        default:
          this.setState({
            isOpenError: true,
            message
          });
      }
    });
  };

  render () {
    let {
      value: { result }
    } = this.props;

    let { value, isOpen, isOpenOutOfOrder, isOpenError, message } = this.state;

    return (<Fragment>
      <ModalConfirmation isOpen={isOpen} toggle={this.toggle('isOpen')} onConfirm={this.confirmModal(value)} />
      <Confirm isOpen={isOpenOutOfOrder} toggle={this.toggle('isOpenOutOfOrder')} onConfirm={() => this.confirm({value, observacao: "Tarefa concluída fora de ordem."})}>Conclusão de tarefa fora da ordem.</Confirm>
      <Confirm isOpen={isOpenError} toggle={this.toggle('isOpenError')} onConfirm={this.toggle('isOpenError')}>{message}</Confirm>
      <Table>
      {result.map((v, i) => (
        <ExpandableRow
        key={i}>
          <td>
            <div>{v.nome}<br />{v.perfil} - {v.completo}</div>
          </td>
          <ExpandedRow style={{backgroundColor:"#EEE"}}>
          <pre>{v.descricao}</pre>
          </ExpandedRow>
        </ExpandableRow>
      ))}
    </Table></Fragment>);
  }
}

let mapStateToProps = ({ agenda }) => ({
  value: agenda.todasAtividades
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaAtividadesPendentes);


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaAtividadesPendentes.js